/*
 * Keeps the last result and recomputes only when its key changes.
 * Template getters run on every change detection (scroll, timers, clicks); without this
 * each run rebuilt the theme object and every row's access object, re-rendering all rows.
 */
export class Memo<T> {
  private key: string | undefined;
  private value: T;

  get(key: string, compute: () => T): T {
    if (key !== this.key) {
      this.key = key;
      this.value = compute();
    }
    return this.value;
  }
}

/** Same as Memo, but one cached value per object (e.g. one per album video row). */
export class ObjectMemo<O extends object, T> {
  private cache = new WeakMap<O, { key: string; value: T }>();

  get(owner: O, key: string, compute: () => T): T {
    const hit = this.cache.get(owner);
    if (hit && hit.key === key) return hit.value;
    const value = compute();
    this.cache.set(owner, { key, value });
    return value;
  }
}
